export const Spinner = ({ label = "Loading" }: { label?: string }) => (
  <div className="flex justify-center" role="status">
    <div className="flex items-center justify-center p-4">
      <div
        className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full"
        aria-hidden="true"
      />
    </div>
    <span className="sr-only">{label}</span>
  </div>
);
